import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { OpenStockFrom } from 'src/app/enum/open-stock-from-enums';
import { ServiceDetailModel } from 'src/app/models/rental/service-detail.model';
import { ServiceModel } from 'src/app/models/rental/service.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { ServiceDetailService } from 'src/app/services/rental/service-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
@Component({
  selector: 'app-register-service-detail',
  templateUrl: './register-service-detail.component.html',
  styleUrls: ['./register-service-detail.component.scss'],
  standalone: false,
})
export class RegisterServiceDetailComponent implements OnInit, OnChanges {

  private readonly articleService = inject(ArticleService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly serviceDetailService = inject(ServiceDetailService);
  private readonly storeService = inject(StoreService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @Input() defaultStoreIdForBranch: number | null = null;
  @Input() serviceDetailContract: ServiceDetailModel = new ServiceDetailModel();
  @Input() serviceModel: ServiceModel = new ServiceModel();
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  articleId: number = 0;
  branchId: number = 0;
  codeNameArticle: string = '';
  columnSortArticle: string | null = null;
  formServiceDetail: FormGroup = new FormGroup({});
  limitArticle: number = 10;
  listConceptInvoicing: any[] = [];
  listStore: any[] = [];
  listUnit: any[] = [];
  minimumQuantityService: number = 0;
  openStockFromService = OpenStockFrom.service;
  pageArticle: number = 1;
  rateDiscount: number = 0;
  serviceDetailId: number = 0;
  unitValueClient: number = 0;

  ngOnInit() {
    this.validateForm(new ServiceDetailModel());
  }

  async ngOnChanges(changes: SimpleChanges) {
    const serviceDetailContract = changes['serviceDetailContract'];
    if (changes['serviceModel']) {
      const service = this.serviceModel;
      if (service.branchId > 0 && service.branchId !== this.branchId) {
        this.branchId = service.branchId;
        await this.getAllLists();
      }
    }
    if (changes['serviceDetailContract'] && !serviceDetailContract.firstChange) {
      const serviceDetail = this.serviceDetailContract;
      const articleId = serviceDetail.articleId;
      const service = this.serviceModel;
      if (serviceDetail && service) {
        this.serviceDetailId = serviceDetail.serviceDetailId;
        if (this.serviceDetailId === 0) {
          this.createNewServiceDetail();
        } else {
          this.validateForm(serviceDetail);
          this.calculateValues();
        }
        await Promise.all([
          this.getArticle(articleId),
          this.getClientValue(service.costCenterId, articleId, false)
        ]);
        this.changeUnit();
        this.formServiceDetail.controls['totalValue']?.disable();
      }
    }
  }

  calculateValues() {
    const quantity = this.formServiceDetail.get('quantity')?.value as number;
    const unitValue = this.formServiceDetail.get('unitValue')?.value as number;
    const totalValue = unitValue * quantity;
    this.formServiceDetail.controls['totalValue'].setValue(totalValue);
  }

  changeDates() {
    const unitId = this.formServiceDetail.get('unitId')?.value as Date;
    const unitSelect = this.listUnit.find((x) => x.value == unitId);
    if (unitSelect) {
      if (unitSelect.code === 'DIA') {
        const dateInitial = this.formServiceDetail.get('dateInitial')
          ?.value as Date;
        const dateFinal = this.formServiceDetail.get('dateFinal')
          ?.value as Date;

        if (dateInitial && dateFinal) {
          // Normalizamos las fechas para ignorar las horas
          const start = new Date(
            dateInitial.getFullYear(),
            dateInitial.getMonth(),
            dateInitial.getDate()
          );
          const end = new Date(
            dateFinal.getFullYear(),
            dateFinal.getMonth(),
            dateFinal.getDate()
          );

          const diffTime = end.getTime() - start.getTime();
          const diffDays = diffTime / (1000 * 60 * 60 * 24) + 1;

          this.formServiceDetail.controls['realQuantity'].setValue(diffDays);
          this.formServiceDetail.controls['quantity'].setValue(diffDays);
        }
      }
    }
  }

  changeHourMeters() {
    let hourMeterInitial = this.formServiceDetail.get('hourMeterInitial')
      ?.value as number;
    let hourMeterFinal = this.formServiceDetail.get('hourMeterFinal')
      ?.value as number;

    if (hourMeterInitial == null) hourMeterInitial = 0;
    if (hourMeterFinal == null) hourMeterFinal = 0;

    const hours =
      this.minimumQuantityService > hourMeterFinal - hourMeterInitial
        ? this.minimumQuantityService
        : hourMeterFinal - hourMeterInitial;
    this.formServiceDetail.controls['realQuantity'].setValue(
      hourMeterFinal - hourMeterInitial
    );
    this.formServiceDetail.controls['quantity'].setValue(hours);
  }

  changeUnit() {
    const unitId = this.formServiceDetail.get('unitId')?.value;
    const selectedUnit = this.listUnit.find(x => x.value == unitId);
    const shouldEnable = selectedUnit?.code === 'HOR';
    const { hourMeterInitial, hourMeterFinal } = this.formServiceDetail.controls;
    if (shouldEnable) {
      setTimeout(() => {
        hourMeterInitial.enable();
        hourMeterFinal.enable();
      });
    } else {
      setTimeout(() => {
        hourMeterInitial.disable();
        hourMeterFinal.disable();
      });
    }
  }

  clearForm() {
    this.rateDiscount = 0;
    this.unitValueClient = 0;
    this.codeNameArticle = '';
    const modelServiceDetailModel = new ServiceDetailModel();
    this.validateForm(modelServiceDetailModel);
    this.isFormView.emit(false);
  }

  createNewServiceDetail() {
    this.serviceDetailId = 0;
    this.serviceDetailContract.document = `SV-${this.serviceModel.consecutive}`;
    this.serviceDetailContract.dateInitial = this.serviceModel.dateService;
    this.serviceDetailContract.dateFinal = this.serviceModel.dateService;
    this.validateForm(this.serviceDetailContract);
  }

  async getAllLists() {
    try {
      const [stores, units, conceptsInvoicing] = await Promise.all([
        firstValueFrom(this.storeService.getAllStoresByBranchForSelectAsync(this.branchId)),
        firstValueFrom(this.serviceDetailService.getAllUnitsForSelectAsync()),
        firstValueFrom(this.serviceDetailService.getAllConceptsInvoicingForSelectAsync()),
      ]);
      this.listStore = stores;
      this.listUnit = units;
      this.listConceptInvoicing = conceptsInvoicing;
      return true;
    } catch (error) {
      console.error('Error getting lists.', error);
      return false;
    }
  }

  async getArticle(articleId: number | null) {
    if (!articleId) {
      this.articleId = 0;
      this.codeNameArticle = '';
      return;
    }
    try {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      this.articleId = articleId;
      this.codeNameArticle = `${article.code} - ${article.name}`;
      if (this.serviceDetailContract.serviceDetailId === 0) {
        setTimeout(() => this.formServiceDetail.controls['unitId'].setValue(article.rentalUnitId));
        this.setStore();
      }
    } catch (error) {
      console.error('Error al obtener el articulo.', error);
    }
  }

  async getClientValue(costCenterId: number, articleId: number, onChanged: boolean) {
    // Con pedido vinculado se respetan los valores del pedido: no se consultan precios del c.costos
    if (this.serviceModel.swOrder && (this.serviceModel.orderId ?? 0) > 0) {
      this.rateDiscount = 0;
      this.unitValueClient = 0;
      this.minimumQuantityService = 0;
      return;
    }
    if (articleId != null && articleId != 0) {
      try {
        const response = await firstValueFrom(this.serviceDetailService.getClientValue(costCenterId, articleId));
        this.rateDiscount = response.rateDiscount;
        this.unitValueClient = response.unitValue;
        this.minimumQuantityService = response.minimumQuantityService;
        if (onChanged) {
          this.formServiceDetail.controls['unitValue'].setValue(response.unitValue);
        }
      } catch (error) {
        this.minimumQuantityService = 0;
        this.articleId = 0;
        this.codeNameArticle = '';
        this.createNewServiceDetail();
        console.error('Error fetching client value for article.', error);
      }
    }
  }

  setStore() {
    if (this.defaultStoreIdForBranch !== 0 && this.serviceDetailId === 0) {
      this.formServiceDetail.controls['storeId'].patchValue(
        this.defaultStoreIdForBranch
      );
    }
  }

  async send() {
    this.formServiceDetail.patchValue({
      serviceId: this.serviceModel.serviceId,
      articleId: this.articleId
    });
    this.validateFormControls();
    if (!this.formServiceDetail.valid) {
      this.showValidationMessages();
      return;
    }
    const modelServiceDetail = this.formServiceDetail.getRawValue() as ServiceDetailModel;
    if (modelServiceDetail.document?.trim() === '') modelServiceDetail.document = null;
    if (this.serviceDetailId == 0) {
      await firstValueFrom(this.serviceDetailService.createServiceDetail(modelServiceDetail));
      this.toastHandlerService.showToast('success', 'El detalle del servicio fue creado exitosamente.');
      this.serviceDetailContract = new ServiceDetailModel();
      this.clearForm();
      this.updateListDetail.emit(true);
    } else {
      this.serviceDetailContract.articleId = modelServiceDetail.articleId;
      this.serviceDetailContract.unitId = modelServiceDetail.unitId;
      this.serviceDetailContract.conceptInvoicingId = modelServiceDetail.conceptInvoicingId;
      this.serviceDetailContract.storeId = modelServiceDetail.storeId;
      this.serviceDetailContract.document = modelServiceDetail.document;
      this.serviceDetailContract.dateInitial = modelServiceDetail.dateInitial;
      this.serviceDetailContract.dateFinal = modelServiceDetail.dateFinal;
      this.serviceDetailContract.hourMeterInitial = modelServiceDetail.hourMeterInitial;
      this.serviceDetailContract.hourMeterFinal = modelServiceDetail.hourMeterFinal;
      this.serviceDetailContract.realQuantity = modelServiceDetail.realQuantity;
      this.serviceDetailContract.quantity = modelServiceDetail.quantity;
      this.serviceDetailContract.unitValue = modelServiceDetail.unitValue;
      this.serviceDetailContract.swToInvoice = modelServiceDetail.swToInvoice;
      try {
        await firstValueFrom(this.serviceDetailService.updateServiceDetail(this.serviceDetailContract));
        this.toastHandlerService.showToast('success', 'El detalle del servicio fue modificado exitosamente.');
        this.serviceDetailContract = new ServiceDetailModel();
        this.clearForm();
        this.updateListDetail.emit(true);
      } catch (error) {
        this.updateListDetail.emit(true);
        console.error('Error updating service detail.', error);
      }
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      serviceId: {
        required: 'El campo Servicio es obligatorio.',
        min: 'Debes seleccionar un Servicio válido.',
      },
      articleId: {
        required: 'El campo Artículo es obligatorio.',
        min: 'Debes seleccionar un Artículo válido.',
      },
      unitId: {
        required: 'El campo Unidad es obligatorio.',
        min: 'Debes seleccionar una Unidad válida.',
      },
      conceptInvoicingId: {
        required: 'El campo Concepto de Facturación es obligatorio.',
        min: 'Debes seleccionar un Concepto válido.',
      },
      storeId: {
        required: 'El campo Bodega es obligatorio.',
        min: 'Debes seleccionar una Bodega válida.',
      },
      document: {
        maxlength: 'El campo Documento no puede tener más de 9 caracteres.',
      },
      dateInitial: {
        required: 'La Fecha Inicial es obligatoria.',
      },
      dateFinal: {
        required: 'La Fecha Final es obligatoria.',
      },
      realQuantity: {
        required: 'El campo Cantidad Real es obligatorio.',
        min: 'La Cantidad Real no puede ser negativa.',
        max: 'La Cantidad Real no puede superar 9.999.999,99.',
      },
      quantity: {
        required: 'El campo Cantidad es obligatorio.',
        min: 'La Cantidad no puede ser negativa.',
        max: 'La Cantidad no puede superar 9.999.999,99.',
      },
      unitValue: {
        required: 'El campo Valor Unitario es obligatorio.',
        min: 'El Valor Unitario no puede ser negativo.',
        max: 'El Valor Unitario no puede superar 99.999.999.999,99.',
      },
      totalValue: {
        required: 'El campo Valor Total es obligatorio.'
      },
      swToInvoice: {
        required: 'El campo Se Factura es obligatorio.',
        min: 'Valor mínimo no válido.',
        max: 'Valor máximo no válido.',
      },
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formServiceDetail.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateRealQuantity(realQuantity: number) {
    if (this.serviceModel.swOrder) {
      const isCreation = (this.serviceDetailContract?.serviceDetailId ?? 0) === 0;
      const topeMaximo = isCreation
        ? (this.serviceDetailContract?.quantityPending ?? 0)
        : (this.serviceDetailContract?.quantityPending ?? 0) + (this.serviceDetailContract?.realQuantity ?? 0);

      if (realQuantity > topeMaximo) {
        this.toastHandlerService.showToast(
          'warning',
          'La cantidad supera el pendiente disponible.'
        );
        setTimeout(() => {
          this.formServiceDetail.patchValue({
            realQuantity: topeMaximo,
            quantity: topeMaximo,
            quantityPending: 0
          });
          this.calculateValues();
        });
        return;
      }
      const nuevoPendiente = topeMaximo - realQuantity;
      setTimeout(() => {
        this.formServiceDetail.patchValue({
          quantity: realQuantity,
          quantityPending: nuevoPendiente
        });
        this.calculateValues();
      });
    }
  }

  async validateForm(serviceDetail: ServiceDetailModel) {
    this.formServiceDetail = this.formBuilder.group({
      quantityPending: [serviceDetail.quantityPending],
      serviceId: [serviceDetail.serviceId, [Validators.required, Validators.min(1)],],
      articleId: [serviceDetail.articleId, [Validators.required, Validators.min(1)],],
      unitId: [serviceDetail.unitId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [serviceDetail.conceptInvoicingId, [Validators.required, Validators.min(1)],],
      storeId: [serviceDetail.storeId, [Validators.required, Validators.min(1)],],
      document: [serviceDetail.document, [Validators.maxLength(9)]],
      hourMeterInitial: [serviceDetail.hourMeterInitial],
      hourMeterFinal: [serviceDetail.hourMeterFinal],
      realQuantity: [serviceDetail.realQuantity, [Validators.required, Validators.min(0), Validators.max(9999999.99)],],
      quantity: [serviceDetail.quantity, [Validators.required, Validators.min(0), Validators.max(9999999.99)],],
      unitValue: [serviceDetail.unitValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)],],
      totalValue: [serviceDetail.quantity * serviceDetail.unitValue, [Validators.required],],
      swToInvoice: [serviceDetail.swToInvoice, [Validators.required],],
      dateInitial: [serviceDetail.dateInitial ? this.dateConverterService.convertUtcToLocalDate(serviceDetail.dateInitial)
        : null, [Validators.required]],
      dateFinal: [serviceDetail.dateFinal ? this.dateConverterService.convertUtcToLocalDate(serviceDetail.dateFinal)
        : null, [Validators.required]],
    });
    const controlDisable: string[] = ['totalValue'];
    if (this.serviceModel.swOrder) {
      controlDisable.push('unitValue', 'quantityPending', 'quantity');
    }
    setTimeout(() =>
      this.formControlStateService.setControlState(this.formServiceDetail, controlDisable, false)
    );
  }

  validateFormControls() {
    Object.keys(this.formServiceDetail.controls).forEach((key) => {
      const control = this.formServiceDetail.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}